
import DeviceStorage from './../../components/DeviceStorage/DeviceStorage';
import store from '../../store';
import settings, { OTT } from '../../devices/all/settings';
import {
    RegisterMethodType, ContractType, PaymentMethodType, InteractionType,
    EVENT_SIGN_UP, EVENT_LOGIN, EVENT_ADD_PAYMENT, EVENT_SELECT_CONTENT, EVENT_VIEW_ITEM, EVENT_INTERACTION_CONTENT, EVENT_BEGIN_CHECKOUT, EVENT_ADD_PAYMENT_INFO, EVENT_PURCHASE, EVENT_CONTENT_PLAY, EVENT_CONTENT_PAUSE, EVENT_CONTENT_BACK, EVENT_CONTENT_ADVANCE, EVENT_INTERACTION_PLAYER, EVENT_CONTENT_PROGRESS, EVENT_SEARCH, EVENT_PRIVACY_POLICES,
    METHOD_IPTELMEX, METHOD_EMAIL,
    PAYMENT_METHOD_TELMEX,
    USER_TYPE_ANONIMO, USER_TYPE_REGISTRADO, PRIVACY_POLICES_CONTINUE, PRIVACY_POLICES_POLICES, PRIVACY_POLICES_TERMS,EVENT_STILL_WATCHING,EVENT_PROGRAM_OPTIONS,DOSFATELMEX,DOES_NOT_APPLY,
    SELECT_CONTENT,
    SERIAL,
    SPORTS,
    SCROLL_DIRECTION,
    SCROLL_MUNDIAL,
    VIEW_ITEM,
    CONTENT_PLAY,
    EVENT_ERROR,
    ACTIVAR_HBO
} from './GA4Constants';
import 'src/extensions/string.extensions';
import Device from "../../devices/device";
import Utils from 'src/utils/Utils';
import getAppConfig from 'src/config/appConfig';
import { DataLayerTransformer } from './ga-api-rest-ps4';
import * as AnalyticsRESTClient from './AnalyticsRESTClient';
import logger from 'src/utils/logger/logger';

declare var window: any;

/**
 * Interfaz para el payload de métricas de selección de contenido (series superdestacadas)
 * Define el contrato explícito del objeto dataMetrics para mejorar type-safety
 */
interface ISelectContentEventSDSeriesPayload {
  event: string;
  client_id: string;
  sign_up_method: string;
  timestamp_micros: number;
  page_path: string;
  page_title: string;
  page_url: string;
  previous_path: string;
  content_section: string;
  content_subsection: string;
  engagement_time_msec: number;
  session_id: string;
  client_id_custom: string;
  device_model: string;
  device_name: string;
  authpn: string;
  content_id: string;
  content_name: string;
  content_type: string;
  content_category: string;
  content_availability: string;
  content_episode: string | null;
  content_price: string;
  content_season: string | null;
  provider: string;
  content_position: number | undefined;
  content_list: string;
  content_list_id: string;
}

/**
 * Clase GA4 para emisión de eventos de métricas
 *
 * NOTA ARQUITECTÓNICA: Esta clase accede a dependencias concretas (store, DeviceStorage, Device)
 * de forma directa. Esto es aceptable porque:
 * - Son singletons de infraestructura global del framework
 * - GA4 es una capa de utilidad transversal, no lógica de negocio core
 * - El costo de inyección de dependencias (DI) sería desproporcionado vs el beneficio
 * - El tipado explícito de payloads mitiga el riesgo de acoplamiento débil
 */

/**
 * Payload de métricas para los eventos de migración AAF → Claro TV+.
 * Se usa tanto en migration_impression como en migration_click.
 * El campo interaction_type es exclusivo de migration_click y se pasa como
 * argumento separado para que la interface sea reutilizable en ambos métodos.
 */
interface IMigrationMetricsPayload {
  /** 'informative' | 'mandatory' — derivado de getConfig().mandatory */
  migration_type: 'informative' | 'mandatory';
  /** screen class, ruta interna en minúsculas y con guiones */
  page_path: string;
  /** screen name, en minúsculas y sin tildes */
  page_title: string;
  /** pantalla anterior — DOES_NOT_APPLY por defecto */
  previous_path: string;
  /** nombre del componente UI */
  modulo_name: string;
}

export class GA4 {

    private dataLayer: any = window.dataLayer || [];
    private user_id: string;
    private debuggMode: boolean = settings.ga4.debugger_enabled;
    private isEnabled: boolean = settings.ga4.eneabled;

    constructor(user_id?: string) {
        this.user_id = user_id || DeviceStorage.getItem('user_id') || '';
    }

    private getUserId(): string {
        const { user: { user_id = '' } = {} } = store.getState() || {};
        return user_id;
    }

    private getParentId(): string {
        const { user: { parent_id = '' } = {} } = store.getState() || {};
        return parent_id;
    }

    private getSubscriptions(): string {
        const { user: { subscriptions } = {} } = store.getState() || {};
        return Utils.getSubscriptions(subscriptions) || DOES_NOT_APPLY;
    }

    private isDebuggingModeAvtive(): boolean {
        return this.debuggMode;
    }

    private send(dataLayer: any, method: any) {

        if (!this.isEnabled) return;

        if (this.isDebuggingModeAvtive()) logger.debug(`%c ***** = [GA4] dataLayer = ***** %c` + JSON.stringify(dataLayer, null, "\t") + `%c `  + method, 'background-color:red; color:black', 'background-color:green',  'background-color:white;color:black;')

        // Delegar al facade cuando el modo REST está activo
        if (AnalyticsRESTClient.isEnabled()) {
            const payload = DataLayerTransformer.transform(dataLayer, this.user_id);
            if (this.isDebuggingModeAvtive()) {
                console.log('%c ***** = [GA4 REST] payload = *****', 'background-color:red; color:black', JSON.stringify(payload, null, '\t'));
            }
            AnalyticsRESTClient.trackEventGA4(payload.events[0], payload.user_id);
            return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayer);

        const {event, ...rest} = dataLayer;
    if (this.isDebuggingModeAvtive())  logger.debug('GA4 ', event, '\n',rest);

    }


    /**
     * ID A1 [Registro] El evento se debe activar con el click en el boton 'SIGUIENTE'
     * @param method Corresponde al método de registro escogido por el usuario
     * @param user_id Corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendRegisterEvent(method: RegisterMethodType, user_id: string, parent_id = this.getParentId(), user_type: string = getUserType(), country: string = getCountry()): void {

        if (!this.isEnabled) return;

        this.send({
            event: EVENT_SIGN_UP,
            method: method,
            user_id: user_id,
            user_type,
            country,
            parent_id
        }, 'A1 [Registro] - sendRegisterEvent');
    }

    /**
     * ID A3 [Registro IpTelmex] el evento se debe activar con la carga de la pantalla de 'Bienvenida'
     * @param user_id Corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     */
    public sendRegisterIPTelmexEvent(user_id = this.getUserId(), parent_id = this.getParentId()): void {

        if (!this.isEnabled) return;

        this.send({
            event: EVENT_SIGN_UP,
            method: METHOD_IPTELMEX,
            user_id: this.getUserId(),
            parent_id,
        }, 'A3 [Registro IpTelmex] - sendRegisterIPTelmexEvent');
    }

    /**
     * ID B1 [inicio sesión] El evento se debe activar con el click en el boton 'SIGUIENTE'
     * @param method corresponde al método de registro escogido por el usuario
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendLoginEvent(method: string = METHOD_EMAIL, user_id = this.getUserId(), parent_id = this.getParentId(), user_type: string = getUserType(), country: string = getCountry()): void {

        if (!this.isEnabled) return;

        this.send({
            event: EVENT_LOGIN,
            method: method,
            user_id,
            user_type,
            country,
            parent_id,
        }, 'B1 [inicio sesión] - sendLoginEvent');
    }

    /**
     * ID C1 El evento se debe activar con con el click en el boton 'CONTINUAR'
     * @param contract_type Corresponde al tipo de contrato [negocio|hogar]
     * @param payment_method Corresponde al método de pago seleccionado por el usuario
     */
    public addPaymentMethodWithContractEvent(contract_type: ContractType, payment_method: typeof PAYMENT_METHOD_TELMEX): void {
        if (!this.isEnabled) return;
        this.send({
            event: EVENT_ADD_PAYMENT,
            payment_method: payment_method,
            contract_type: contract_type,
        }, 'C1 - addPaymentMethodWithContractEvent');
    }

    /**
     * ID C2, C3, C4
     * @param payment_method corresponde al método de pago seleccionado por el usuario
     */
    public sendAddPaymentMethodEvent(payment_method: PaymentMethodType, user_id = this.getUserId(), parent_id = this.getParentId()): void {
        if (!this.isEnabled) return;
        this.send({
            event: EVENT_ADD_PAYMENT,
            payment_method: payment_method,
            user_id,
            parent_id,
        }, 'ID C2, C3, C4 - sendAddPaymentMethodEvent');
    }

    /**
     * D1-D10, D12 El evento se debe activar con el click en el contenido que seleccione el usuario
     * @param section Nombre del nodo en el que se encuentra el usuario
     * @param list Corresponde al nombre de la lista de carruseles disponibles
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param type [pelicula|serie|documental|canal tv]
     * @param category Categorías a la que pertenece el contenido
     * @param availability [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendSelectContentEvent(section: string, list: string, id: string, name: string, type: string, category: string, availability: string,
        content_position: string, user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(), parent_id = this.getParentId()): void {

        if (!this.isEnabled) return;

        const content_id = (id)?.toString().clearString();

        const dataLayer = {
            event: EVENT_SELECT_CONTENT,
            content_section: section?.clearString(),
            content_list: list?.clearString(),
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_position: content_position,
            user_type,
            user_id,
            country,
            parent_id
        }

        this.send(dataLayer, 'ID D1-D10, D12 - sendSelectContentEvent');
    }

    /**
     * D11 [Selección de contenido - Inicio] El evento se debe activar con el click de alguno de los 2 botones
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param category Tipo de contenido Ejem. [pelicula|serie|documental|canal tv]
     * @param category2 Categorías a las que pertenece el contenido Ejem. [{categorías a la que pertenece el contenido}|no aplica]
     * @param category3 Tipo de disponibilidad del contenido [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param category4 [temporada{numero}|episodio{numero y nombre}|no aplica]
     * @param brand Marca de la suscripción Ejem. [hbo|claro video|fox sport|noggin|edye|paramount]
     * @param list_name [home inicio|vcard|player|fin player|player tv]
     * @param price Precio del contenido |.00
     * @param quantity Cantidad
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendPlanSelectorEvent(id: string, name: string,
        category: string, category2: string, category3: string, category4: string,
        brand: string, list_name: string, price: string, quantity: number,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(),
        parent_id = this.getParentId()) {

        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_BEGIN_CHECKOUT,
            item_id: id,
            item_name: name?.clearString(),
            item_category: category?.clearString(),
            item_category2: category2?.clearString(),
            item_category3: category3?.clearString(),
            item_category4: category4?.clearString(),
            item_brand: brand?.clearString(),
            item_list_name: list_name?.clearString(),
            price: price?.clearCurrency(),
            quantity: quantity,
            user_type,
            country,
            user_id,
            parent_id
        }
        this.send(dataLayer, 'D11 [Selección de contenido - Inicio] - sendPlanSelectorEvent');
    }

    /**
     * D13 [Selección de contenido - Vcard] El evento se debe activar con el click en el contenido que seleccione el usuario
     * @param section Nombre del nodo en el que se encuentra el usuario
     * @param list Corresponde al nombre de la lista de carruseles disponibles
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param type [pelicula|serie|documental|canal tv]
     * @param category Categorías a la que pertenece el contenido
     * @param availability [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param episode Nnombre y número del episodio
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendSelectContentSerieEvent(section: string, list: string, id: string, name: string, type: string, category: string, availability: string, episode: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(),
        parent_id = this.getParentId()): void {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_SELECT_CONTENT,
            content_section: section?.clearString(),
            content_list: list?.clearString(),
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            user_type,
            country,
            user_id,
            parent_id
        }
        this.send(dataLayer, 'D13 [Selección de contenido - Vcard] - sendSelectContentSerieEvent');
    }

    /**
     * E1 El evento se debe activar cuando cargue el detalle del contenido seleccionado por el usuario
     * @param id Identificador único del contenido
     * @param name Nnombre del contenido
     * @param category [pelicula|serie|documental|canal tv]
     * @param category2 Categorías a la que pertenece el contenido
     * @param category3 [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param category4 [temporada{numero}|episodio{numero y nombre}|no aplica]
     * @param brand [hbo|claro video|fox sport|noggin|edye|paramount|no aplica]
     * @param list_name [home inicio|vcard|player|fin player|player tv]
     * @param price [Precio del contenido|0.00]
     * @param quantity 1
     */
    public sendContentDetailEvent(id: string, name: string,
        category: string, category2: string, category3: string, category4: string,
        brand: string, list_name: string, price: string, quantity: number = 1, user_id = this.getUserId(), parent_id = this.getParentId()) {

        if (!this.isEnabled) return;

            const dataLayer: any = {
            event: EVENT_VIEW_ITEM,
            ecommerce: {
            items: [{
                item_id: id,
                item_name: name?.clearString(),
                item_category: category?.clearString(),
                item_category2: category2?.clearString(),
                item_category3: category3?.clearString(),
                item_category4: category4?.clearString(),
                item_brand: brand?.clearString(),
                item_list_name: list_name?.clearString(),
                price: price?.clearCurrency(),
                quantity: quantity,
                user_id: user_id,
                parent_id: parent_id
            }]
        }}
        this.send(dataLayer, 'E1 [Selección de contenido - Vcard] - sendContentDetailEvent');
}


    /**
     * E2 El evento se debe activar con el click sobre cualquiera de las opciones señaladas y escogida por el usuario
     * @param interactionType Nombre de la interacción [reproducir|ver trailer|quitar de mi lista|agregar a mi lista]
     * @param section Nombre del nodo en el que se encuentra el usuario
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param contentType Tipo de contenido [pelicula|serie|documental|canal tv]
     * @param category Categorías a la que pertenece el contenido [comedia, accion, drama, ciencia ficcion]
     * @param availability Tipo de disponibilidad del contenido [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendInteractContentEvent(interactionType: InteractionType, section: string,
        id: string, name: string, contentType: string, category: string, availability: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(),
        country: string = getCountry(), parent_id = this.getParentId()) {

        if (!this.isEnabled) return;


        const dataLayer = {
            event: EVENT_INTERACTION_CONTENT,
            interaction_type: interactionType,
            content_section: section?.clearString(),
            item_id: id?.clearString(),
            content_name: name?.clearString(),
            content_type: contentType?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            user_type,
            country,
            user_id,
            parent_id,
        }
        this.send(dataLayer, 'E2 [Selección de contenido - Vcard] - sendInteractContentEvent');
    }


    /**
     * ID'S E4-E10 El evento se debe activar con el click sobre cualquiera de las opciones señaladas y escogida por el usuario
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param category Tipo de contenido [pelicula|serie|documental|canal tv]
     * @param category2 Categorías a las que pertenece el contenido | no aplica
     * @param category3 Tipo de disponibilidad del contenido [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param category4 Numero de temporada o numero y nombre de episodio [temporada{numero}|episodio{numero y nombre}|no aplica]
     * @param brand Marca de la suscripción [hbo|claro video|fox sport|noggin|edye|paramount|no aplica]
     * @param list_name Ubicación dentro del sitio web
     * @param price Precio del contenido [{precio del contenido}|0.00]
     * @param quantity Cantidad a comprar
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendStartCheckoutEvent(id: string, name: string,
        category: string, category2: string, category3: string, category4: string,
        brand: string, list_name: string, price: string, quantity: number = 1,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(),
        parent_id = this.getParentId()) {


        const dataLayer = {
            event: EVENT_BEGIN_CHECKOUT,
            ecommerce: {
            items: [{
                item_id: id,
                item_name: name?.clearString(),
                item_category: category?.clearString(),
                item_category2: category2?.clearString(),
                item_category3: category3?.clearString(),
                item_category4: category4?.clearString(),
                item_brand: brand?.clearString(),
                item_list_name: list_name?.clearString(),
                price: price?.clearCurrency(),
                quantity: quantity,
                user_type,
                country,
                user_id,
                parent_id
                }
                ]
            }
        }
        this.send(dataLayer, 'E4-E10 [Detalle de contenido - Sin derecho (usuario registrado con prepago)] - sendStartCheckoutEvent');
    }

    /**
     * ID F1-F2 El evento se debe activar con el click en el boton 'CONTRATAR' / 'ALQUILAR'
     * @param type Corresponde al método de pago seleccionado por el usuario.
     * @param name
     * @param id
     * @param price
     * @param brand
     * @param category
     * @param category2
     * @param category3
     * @param category4
     * @param quantity
     */
    public sendPaymentMethodAddedEvent(type: string, name: string, id: string, price: string, brand: string, category: string, category2: string, category3: string, category4: string, quantity: number = 1,  user_id: string = this.getUserId(), parent_id = this.getParentId()) {

        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_ADD_PAYMENT_INFO,
            ecommerce: {
            payment_type: type,
            items: [{
                item_name: name?.clearString(),
                item_id: id?.clearString(),
                price: price?.clearCurrency(),
                item_brand: brand?.clearString(),
                item_category: category?.clearString(),
                item_category2: category2?.clearString(),
                item_category3: category3?.clearString(),
                item_category4: category4?.clearString(),
                quantity: quantity,
                user_id,
                parent_id
            }]
            }
        }
        this.send(dataLayer, 'F1 [Compra - Agregar medio de pago] - sendPaymentMethodAddedEvent');
    }

    /**
     *
     * @param value Valor total de la compra
     * @param transactionId Identificador de la transacción
     * @param cupon Número del cupon utilizado
     * @param name
     * @param itemId
     * @param price
     * @param brand
     * @param category
     * @param category2
     * @param category3
     * @param category4
     * @param quantity
     */
    public sendBuyEvent(value: string, transactionId: string, cupon: string, name: string, itemId: string, price: string, brand: string,
        category: string, category2: string, category3: string, category4: string, quantity: number = 1) {

        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_PURCHASE,
            ecommerce: {
                value: value.clearCurrency(),
                transaction_id: transactionId?.clearString(),
                cupon: cupon?.clearString(),
                items:[{
                    item_name: name?.clearString(),
                    item_id: itemId?.clearString(),
                    price: price?.clearCurrency(),
                    item_brand: brand?.clearString(),
                    item_category: category?.clearString(),
                    item_category2: category2?.clearString(),
                    item_category3: category3?.clearString(),
                    item_category4: category4?.clearString(),
                    quantity: quantity,
                }]

        }}
        this.send(dataLayer, 'F3 [Compra - Compra] - sendBuyEvent');
    }

    /**
     *
     * @param id
     * @param name
     * @param type
     * @param category
     * @param availability
     * @param episode
     * @param list
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendPlayContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(),  parent_id = this.getParentId()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_PLAY,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
            parent_id,
        }
        this.send(dataLayer, 'G1 [Reproductor - Reproducción de contenido] - sendPlayContentEvent');
    }

    public sendPauseContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(), parent_id = this.getParentId()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_PAUSE,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
            parent_id
        }
        this.send(dataLayer, 'G2 [Reproductor - Reproducción de contenido] - sendPauseContentEvent');
    }

    public sendBackContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(),  parent_id = this.getParentId()) {

        if (!this.isEnabled) return;
        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_BACK,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
            parent_id,
        }
        this.send(dataLayer, 'G3 [Reproductor - Reproducción de contenido] - sendBackContentEvent');
    }

    public sendAdvanceContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(), parent_id = this.getParentId()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_ADVANCE,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
            parent_id
        }
        this.send(dataLayer, 'G4 [Reproductor - Reproducción de contenido] - sendAdvanceContentEvent');
    }

    public sendInteractionContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(), parent_id = this.getParentId()
        ) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_INTERACTION_PLAYER,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
            parent_id,
        }
        this.send(dataLayer, 'G5 [Reproductor - Reproducción de contenido] - sendInteractionContentEvent');
    }

    public sendProgressContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string, progress_percentage: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(), parent_id = this.getParentId()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_PROGRESS,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            progress_percentage: progress_percentage,
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
            parent_id
        }
        this.send(dataLayer, 'G6 [Reproductor - Reproducción de contenido] - sendProgressContentEvent');
    }

    public sendStillWatchingContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(), parent_id = this.getParentId()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_STILL_WATCHING,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            message: 'continuar',
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
            parent_id
        }
        this.send(dataLayer, 'G6 [Reproductor - Reproducción de contenido] - sendProgressContentEvent');
    }

    public sendProgramOptionsContentEvent(interaction_type: string, id: string, name: string, category: string, availability: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry(), parent_id = this.getParentId()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_PROGRAM_OPTIONS,
            interaction_type: interaction_type,
            content_id,
            content_name: name?.clearString(),
            content_type: 'canal tv',
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_list: 'no aplica',
            user_type,
            country,
            user_id,
            parent_id
        }
        this.send(dataLayer, 'G6 [Reproductor - Reproducción de contenido] - sendProgressContentEvent');
    }

    /**
     * H1. El evento se debe activar cuando se escriban mínimo 3 letras en el motor de busqueda
     * @param term Termino de búsqueda
     */
    public sendSearchEvent(term: string,  user_id: string = this.getUserId(), country: string = getCountry(), parent_id = this.getParentId()) {
        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_SEARCH,
            search_term: term?.clearString(),
            user_id,
            country,
            parent_id,
        }
        this.send(dataLayer, 'H1 [Buscador - Buscador] - sendSearchEvent');
    }

    public sendPrivacyPolices(selection: string = PRIVACY_POLICES_CONTINUE || PRIVACY_POLICES_POLICES || PRIVACY_POLICES_TERMS,
        user_id: string = this.getUserId(),
        user_type: string = getUserType(),
        country: string = getCountry(),
        parent_id = this.getParentId(),
    ) {

        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_PRIVACY_POLICES,
            selection: selection,
            method: METHOD_EMAIL,
            user_id,
            user_type,
            country,
            parent_id
        }
        this.send(dataLayer, 'I1 [Politicas de Privacidad - Politicas] - sendSearchEvent');
    }

    /**
     * @param client_id identificador del dispositivo en el cual se está accediendo a la aplicación
     * @param parent_id identificador único del admin cuenta
     * @param user_properties
     ***@param sign_up_method método con el que se registró
     ***@param user_type Tipo de usuario anonimo|registrado
     ***@param suscriptions títulos de cada suscripción activa, únicamente separados por coma
     ***@param page_path valor fijo ejemplo: /autenticacion/telmex/confirmacion
     ***@param page_title Valor fijo nombre de la página
     * @param timestamp_micros representa la marca de tiempo de un evento en microsegundos desde la época Unix (1 de enero de 1970 a las 00:00:00 UTC)
     * @param page_url no aplica
     * @param previous_path URL del navegador anterior
     * @param content_section URL del navegador nodo actual
     * @param device Configuración del dispositivo
     * @param os_version Configuración del dispositivo
     * @param country país actual
     * @param engagement_time_msec debe reflejar tiempo de participación del evento en milisegundos
     * @param session_id identificador de cada visita del usario
     * @param content_id identificador único y númerico del contenido
     * @param content_name nombre del contenido
     * @param content_type tipo de contenido
     * @param content_category categorías a las que pertenece el contenido
     * @param content_availability tipo de disponibilidad del contenido
     * @param content_episode nombre de la temporada y título del episodio
     * @param interaction_type Valor fijo Descripción de la acción/botón
     * @param modulo_name Valor fijo nombre del módulo
     * @param method valor fijo ip telmex
     * @param destination_channel canal al que fue enviado el mensaje no aplica
     * @param authpn
     */
    public sendMetrics2FA(getParamsMetrics2FA: any, interaction_type: string ){

        const dataLayer = {
            event: DOSFATELMEX,
            user_id: this.getUserId(),
            client_id: "1727740805000000",//Pendiente con métricas
            parent_id: this.getParentId(),
            modulo_name: getParamsMetrics2FA.modulo_name || '',
            interaction_type: interaction_type,
            user_properties: {
                sign_up_method: {
                    value: "ip telmex" //Pendiente con métricas
                },
                user_type: {
                    value: getUserType()
                },
                suscriptions: {
                    value: this.getSubscriptions()
                },
                page_path: {
                    value: getParamsMetrics2FA.page_path || ''
                },
                page_title: {
                    value: getParamsMetrics2FA.page_title || ''
                }
            },
            events: [
                {
                timestamp_micros: getParamsMetrics2FA.timestamp_micros || '',
                params: {
                    page_url: "no aplica",
                    previous_path: getParamsMetrics2FA.previous_path || '',
                    content_section: getParamsMetrics2FA.content_section || '',
                    content_subsection: "no aplica",
                    device: Device.getDevice().getPlatform() || '',
                    os_version: Device.getDevice().getPlatform(),
                    country: getCountry(),
                    engagement_time_msec: getParamsMetrics2FA.timestamp_micros || '',//Pendiente con métricas
                    session_id: "12345.67890.1609459200.3141",//Pendiente con métricas
                    content_id: getParamsMetrics2FA.content_id || '',
                    content_name: getParamsMetrics2FA.content_name || '',
                    content_type: getParamsMetrics2FA.content_type || '',
                    content_category: getParamsMetrics2FA.content_category || '',
                    content_availability: getParamsMetrics2FA.content_availability || '',
                    content_episode: getParamsMetrics2FA.content_episode || '',
                    destination_channel: getParamsMetrics2FA.destination_channel || '',
                    }
                }
            ]
        }
        this.send(dataLayer, '[2FA]');
    }


    private cleanDataLayer(obj: any): any {
        const cleaned: any = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const value = obj[key];
                if (value !== null && value !== undefined && value !== '') {
                    cleaned[key] = value;
                }
            }
        }
        return cleaned;
    }

    public sendMetricsRecoverPassword(dataMetrics: any) {
        const dataLayerRaw = this.cleanDataLayer({
            event: dataMetrics.event,
            client_id: dataMetrics.client_id,
            user_id: this.getUserId(),
            parent_id: this.getParentId(),
            sign_up_method: dataMetrics.sign_up_method,
            user_type: getUserType(),
            timestamp_micros: dataMetrics.timestamp_micros,
            suscriptions: this.getSubscriptions(),
            page_path: dataMetrics.page_path,
            page_title: dataMetrics.page_title,
            page_url: dataMetrics.page_url,
            previous_path: dataMetrics.previous_path,
            content_section: dataMetrics.content_section,
            content_subsection: dataMetrics.content_subsection,
            device: Device.getDevice().getPlatform(),
            os_version: Device.getDevice().getPlatform(),
            country: getCountry(),
            engagement_time_msec: dataMetrics.engagement_time_msec,
            session_id: dataMetrics.session_id,
            interaction_type: dataMetrics.interaction_type,
            modulo_name: dataMetrics.module_name
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }

    public sendMetricsOnboardingIPTelmex(dataMetrics: any) {
        const dataLayer = this.cleanDataLayer({
            event: dataMetrics.event,
            timestamp_micros: dataMetrics.timestamp_micros || 'no aplica',
            client_id: dataMetrics.client_id || 'no aplica',
            user_id: this.getUserId() || 'no aplica',
            parent_id: this.getParentId() || 'no aplica',
            sign_up_method: dataMetrics.sign_up_method || 'no aplica',
            client_id_custom: dataMetrics.client_id || 'no aplica',
            user_id_custom: this.getUserId() || 'no aplica',
            user_type: getUserType() || 'no aplica',
            suscriptions: Utils.getSubscriptions(store.getState().user.subscriptions) || 'no aplica',
            page_path: dataMetrics.page_path || 'no aplica',
            page_title: dataMetrics.page_title || 'no aplica',
            page_ur: dataMetrics.page_url || 'no aplica',
            previous_path: dataMetrics.previous_path || 'no aplica',
            content_section: dataMetrics.content_section || 'no aplica',
            content_subsection: dataMetrics.content_subsection || 'no aplica',
            device: Device.getDevice().getPlatform() || 'no aplica',
            os_version: Device.getDevice().getPlatform() || 'no aplica',
            country_id: getCountry() || 'no aplica',
            engagement_time_msec: dataMetrics.engagement_time_msec || 'no aplica',
            session_id: dataMetrics.session_id || 'no aplica',
            interaction_type: dataMetrics.interaction_type || 'no aplica',
            modulo_name: dataMetrics.modulo_name || 'no aplica',
            method: dataMetrics.method || 'no aplica',
        })
        this.send(dataLayer, '[Onboarding IPTelmex]');
    }

    public sendMetricsMundialFase2SelectContent(dataMetrics: any) {
        const dataLayerRaw = this.cleanDataLayer({
            event: SELECT_CONTENT,
            timestamp_micros: Utils.nowAsTimestampSeconds() * 1000000,
            client_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id: this.getUserId() || DOES_NOT_APPLY,
            user_id_custom: this.getUserId() || DOES_NOT_APPLY,
            parent_id: this.getParentId() || DOES_NOT_APPLY,
            parent_id_custom: this.getParentId() || DOES_NOT_APPLY,
            client_id_custom: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            sign_up_method: store.getState().user.type === OTT ? METHOD_EMAIL : SERIAL || DOES_NOT_APPLY,
            user_type: getUserType() || DOES_NOT_APPLY,
            suscriptions: this.getSubscriptions(),
            page_path: dataMetrics.page_path || DOES_NOT_APPLY,
            page_title: dataMetrics.page_title || DOES_NOT_APPLY,
            page_url: dataMetrics.page_url || DOES_NOT_APPLY,
            previous_path: dataMetrics.history && dataMetrics.history.location && dataMetrics.history.location.pathname ? dataMetrics.history.location.pathname : DOES_NOT_APPLY,
            content_section: dataMetrics.content_section || DOES_NOT_APPLY,
            content_subsection: dataMetrics.content_subsection || DOES_NOT_APPLY,
            device: Device.getDevice().getPlatform() || DOES_NOT_APPLY,
            device_model: Device.getDevice().config.device_model || DOES_NOT_APPLY,
            device_name: Device.getDevice().config.device_name || DOES_NOT_APPLY,
            country: getCountry() || DOES_NOT_APPLY,
            engagement_time_msec: Utils.nowAsTimestampSeconds() * 1000000,
            session_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            modulo_name: dataMetrics.modulo_name || DOES_NOT_APPLY,
            provider: dataMetrics.provider || DOES_NOT_APPLY,
            status_card: dataMetrics.match.statusCard || DOES_NOT_APPLY,
            authpn: getAppConfig().authpn || DOES_NOT_APPLY,
            content_id: dataMetrics.match.contentId || DOES_NOT_APPLY,
            content_name: dataMetrics.match.contentName || DOES_NOT_APPLY,
            content_type: dataMetrics.content_type || DOES_NOT_APPLY,
            content_category: SPORTS || DOES_NOT_APPLY,
            content_availability: dataMetrics.content_availability || DOES_NOT_APPLY,
            interaction_type: dataMetrics.interaction_type || DOES_NOT_APPLY,
            content_location: dataMetrics.match.contentLocation || DOES_NOT_APPLY,
            content_start_date: dataMetrics.match.contentStartDate || DOES_NOT_APPLY,
            final_score: dataMetrics.match.finalScore || DOES_NOT_APPLY,
            match_winner: dataMetrics.match.matchWinner || DOES_NOT_APPLY,
            match_time: dataMetrics.match.matchTime || DOES_NOT_APPLY
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }

    public sendMetricsMundialFase2Scroll(dataMetrics: any) {
        const dataLayerRaw = this.cleanDataLayer({
            event: SCROLL_MUNDIAL,
            timestamp_micros: Utils.nowAsTimestampSeconds() * 1000000,
            client_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id: this.getUserId() || DOES_NOT_APPLY,
            parent_id: this.getParentId() || DOES_NOT_APPLY,
            sign_up_method: store.getState().user.type === OTT ? METHOD_EMAIL : SERIAL,
            client_id_custom: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id_custom: this.getUserId() || DOES_NOT_APPLY,
            user_type: getUserType() || DOES_NOT_APPLY,
            parent_id_custom: this.getParentId() || DOES_NOT_APPLY,
            suscriptions: this.getSubscriptions(),
            page_path: dataMetrics.page_path || DOES_NOT_APPLY,
            page_title: dataMetrics.page_title || DOES_NOT_APPLY,
            page_url: dataMetrics.page_url || DOES_NOT_APPLY,
            previous_path: dataMetrics.previous_path || DOES_NOT_APPLY,
            engagement_time_msec: Utils.nowAsTimestampSeconds() * 1000000,
            session_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            device: Device.getDevice().getPlatform() || DOES_NOT_APPLY,
            device_model: Device.getDevice().config.device_model || DOES_NOT_APPLY,
            authpn: dataMetrics.authpn || DOES_NOT_APPLY,
            modulo_name: dataMetrics.modulo_name || DOES_NOT_APPLY,
            content_section: dataMetrics.content_section || DOES_NOT_APPLY,
            content_subsection: dataMetrics.content_subsection || DOES_NOT_APPLY,
            content_type: dataMetrics.content_type || DOES_NOT_APPLY,
            provider: dataMetrics.provider || DOES_NOT_APPLY,
            country: getCountry() || DOES_NOT_APPLY,
            interaction_type: dataMetrics.interaction_type || DOES_NOT_APPLY,
            os_version: Device.getDevice().config.osversion || DOES_NOT_APPLY,
            scroll_direction: SCROLL_DIRECTION || DOES_NOT_APPLY,
            scroll_percentage: dataMetrics.scroll_percentage || DOES_NOT_APPLY,
            visible_content_id: dataMetrics.visible_content_id || DOES_NOT_APPLY
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }

    public sendMetricsMundialFase2ViewItem(dataMetrics: any) {
        const dataLayerRaw = this.cleanDataLayer({
            event: VIEW_ITEM,
            timestamp_micros: Utils.nowAsTimestampSeconds() * 1000000,
            client_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id: this.getUserId() || DOES_NOT_APPLY,
            user_id_custom: this.getUserId() || DOES_NOT_APPLY,
            parent_id: this.getParentId() || DOES_NOT_APPLY,
            client_id_custom: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            sign_up_method: store.getState().user.type === OTT ? METHOD_EMAIL : SERIAL || DOES_NOT_APPLY,
            user_type: getUserType() || DOES_NOT_APPLY,
            suscriptions: this.getSubscriptions(),
            page_path: dataMetrics.page_path || DOES_NOT_APPLY,
            page_title: dataMetrics.page_title || DOES_NOT_APPLY,
            page_url: dataMetrics.page_url || DOES_NOT_APPLY,
            previous_path: dataMetrics.history && dataMetrics.history.location && dataMetrics.history.location.pathname ? dataMetrics.history.location.pathname : DOES_NOT_APPLY,
            content_section: dataMetrics.content_section || DOES_NOT_APPLY,
            content_subsection: dataMetrics.content_subsection || DOES_NOT_APPLY,
            device: Device.getDevice().getPlatform() || DOES_NOT_APPLY,
            device_model: Device.getDevice().config.device_model || DOES_NOT_APPLY,
            device_name: Device.getDevice().config.device_name || DOES_NOT_APPLY,
            os_version: Device.getDevice().config.osversion || DOES_NOT_APPLY,
            country: getCountry() || DOES_NOT_APPLY,
            engagement_time_msec: Utils.nowAsTimestampSeconds() * 1000000,
            session_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            modulo_name: dataMetrics.modulo_name || DOES_NOT_APPLY,
            provider: dataMetrics.provider || DOES_NOT_APPLY,
            status_card: dataMetrics.status_card || DOES_NOT_APPLY,
            authpn: getAppConfig().authpn || DOES_NOT_APPLY,
            content_id: dataMetrics.content_id || DOES_NOT_APPLY,
            content_name: dataMetrics.content_name || DOES_NOT_APPLY,
            content_type: dataMetrics.content_type || DOES_NOT_APPLY,
            content_category: SPORTS || DOES_NOT_APPLY,
            content_availability: dataMetrics.content_availability || DOES_NOT_APPLY,
            interaction_type: dataMetrics.interaction_type || DOES_NOT_APPLY,
            item_id: dataMetrics.item_id || DOES_NOT_APPLY,
            item_name: dataMetrics.item_name || DOES_NOT_APPLY,
            item_brand: dataMetrics.item_brand || DOES_NOT_APPLY,
            item_category: SPORTS || DOES_NOT_APPLY,
            item_category2: dataMetrics.item_category2 || DOES_NOT_APPLY,
            item_category3: dataMetrics.item_category3 || DOES_NOT_APPLY,
            item_category4: dataMetrics.item_category4 || DOES_NOT_APPLY,
            item_variant: dataMetrics.item_variant || DOES_NOT_APPLY,
            item_list_name: dataMetrics.item_list_name || DOES_NOT_APPLY,
            index: dataMetrics.index || DOES_NOT_APPLY,
            price: dataMetrics.price || DOES_NOT_APPLY,
            item_stats_detail: dataMetrics.item_stats_detail || DOES_NOT_APPLY,
            visible_content_id: dataMetrics.visible_content_id || DOES_NOT_APPLY,
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }

    public sendMetricsMundialFase2ContentPlay(dataMetrics: any) {
        const dataLayerRaw = this.cleanDataLayer({
            event: CONTENT_PLAY,
            timestamp_micros: Utils.nowAsTimestampSeconds() * 1000000,
            client_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id: this.getUserId() || DOES_NOT_APPLY,
            user_id_custom: this.getUserId() || DOES_NOT_APPLY,
            parent_id: this.getParentId() || DOES_NOT_APPLY,
            parent_id_custom: this.getParentId() || DOES_NOT_APPLY,
            client_id_custom: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            sign_up_method: store.getState().user.type === OTT ? METHOD_EMAIL : SERIAL || DOES_NOT_APPLY,
            user_type: getUserType() || DOES_NOT_APPLY,
            suscriptions: this.getSubscriptions(),
            page_path: dataMetrics.page_path || DOES_NOT_APPLY,
            page_title: dataMetrics.page_title || DOES_NOT_APPLY,
            page_url: dataMetrics.page_url || DOES_NOT_APPLY,
            previous_path: dataMetrics.previous_path || DOES_NOT_APPLY,
            content_section: dataMetrics.content_section || DOES_NOT_APPLY,
            content_subsection: dataMetrics.content_subsection || DOES_NOT_APPLY,
            device: Device.getDevice().getPlatform() || DOES_NOT_APPLY,
            device_model: Device.getDevice().config.device_model || DOES_NOT_APPLY,
            device_name: Device.getDevice().config.device_name || DOES_NOT_APPLY,
            os_version: Device.getDevice().config.osversion || DOES_NOT_APPLY,
            country: getCountry() || DOES_NOT_APPLY,
            engagement_time_msec: Utils.nowAsTimestampSeconds() * 1000000,
            session_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            modulo_name: dataMetrics.modulo_name || DOES_NOT_APPLY,
            provider: dataMetrics.provider || DOES_NOT_APPLY,
            status_card: dataMetrics.match.statusCard || DOES_NOT_APPLY,
            authpn: getAppConfig().authpn || DOES_NOT_APPLY,
            content_id: dataMetrics.match.contentId || DOES_NOT_APPLY,
            content_name: dataMetrics.match.contentName || DOES_NOT_APPLY,
            content_type: dataMetrics.content_type || DOES_NOT_APPLY,
            content_category: SPORTS || DOES_NOT_APPLY,
            content_availability: dataMetrics.content_availability || DOES_NOT_APPLY,
            interaction_type: dataMetrics.interaction_type || DOES_NOT_APPLY,
            content_location: dataMetrics.match.contentLocation || DOES_NOT_APPLY,
            content_start_date: dataMetrics.match.contentStartDate || DOES_NOT_APPLY,
            final_score: dataMetrics.match.finalScore || DOES_NOT_APPLY,
            match_winner: dataMetrics.match.matchWinner || DOES_NOT_APPLY,
            match_time: dataMetrics.match.matchTime || DOES_NOT_APPLY,
            is_live: true,
            tournament_round: dataMetrics.modulo_name || DOES_NOT_APPLY,
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }


    public sendMetricsSelectContentMundial(dataMetrics: any) {
        const dataLayerRaw = this.cleanDataLayer({
            event: dataMetrics.event,
            timestamp_micros: dataMetrics.timestamp_micros,
            client_id: dataMetrics.client_id,
            user_id: this.getUserId(),
            user_id_custom: this.getUserId(),
            parent_id: this.getParentId(),
            parent_id_custom: this.getParentId(),
            client_id_custom: dataMetrics.client_id,
            sign_up_method: dataMetrics.sign_up_method,
            user_type: getUserType(),
            suscriptions: this.getSubscriptions(),
            page_path: dataMetrics.page_path,
            page_title: dataMetrics.page_title,
            page_url: dataMetrics.page_url,
            previous_path: dataMetrics.previous_path,
            content_section: dataMetrics.content_section,
            content_subsection: dataMetrics.content_subsection,
            device: Device.getDevice().getPlatform(),
            os_version: Device.getDevice().config.osversion,
            country: getCountry(),
            engagement_time_msec: dataMetrics.engagement_time_msec,
            session_id: dataMetrics.session_id,
            modulo_name: dataMetrics.module_name,
            provider: DOES_NOT_APPLY,
            status_card: DOES_NOT_APPLY,
            authpn: dataMetrics.authpn,
            content_id: DOES_NOT_APPLY,
            content_name: DOES_NOT_APPLY,
            content_type: DOES_NOT_APPLY,
            content_category: DOES_NOT_APPLY,
            content_availability: DOES_NOT_APPLY,
            interaction_type: dataMetrics.interaction_type,
            content_location: DOES_NOT_APPLY,
            content_start_date: DOES_NOT_APPLY,
            final_score: DOES_NOT_APPLY,
            match_winner: DOES_NOT_APPLY,
            match_time: DOES_NOT_APPLY
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }

    /**
     * Envía evento de selección de contenido para series del carrusel superdestacados (STVCL-1147)
     * @param dataMetrics Payload tipado con toda la información del evento de selección
     */
    public sendSelectContentEventSDSeries(dataMetrics: ISelectContentEventSDSeriesPayload): void {
        const dataLayerRaw = this.cleanDataLayer({
            event: dataMetrics.event || DOES_NOT_APPLY,
            client_id: dataMetrics.client_id || DOES_NOT_APPLY,
            user_id: this.getUserId() || DOES_NOT_APPLY,
            parent_id: this.getParentId() || DOES_NOT_APPLY,
            sign_up_method: dataMetrics.sign_up_method || DOES_NOT_APPLY,
            user_type: getUserType() || DOES_NOT_APPLY,
            timestamp_micros: dataMetrics.timestamp_micros || DOES_NOT_APPLY,
            suscriptions: this.getSubscriptions(),
            page_path: dataMetrics.page_path || DOES_NOT_APPLY,
            page_title: dataMetrics.page_title || DOES_NOT_APPLY,
            page_url: dataMetrics.page_url || DOES_NOT_APPLY,
            previous_path: dataMetrics.previous_path || DOES_NOT_APPLY,
            content_section: dataMetrics.content_section || DOES_NOT_APPLY,
            content_subsection: dataMetrics.content_subsection || DOES_NOT_APPLY,
            device: Device.getDevice().getPlatform() || DOES_NOT_APPLY,
            os_version: Device.getDevice().getPlatform() || DOES_NOT_APPLY,
            country: getCountry() || DOES_NOT_APPLY,
            engagement_time_msec: dataMetrics.engagement_time_msec || DOES_NOT_APPLY,
            session_id: dataMetrics.session_id || DOES_NOT_APPLY,
            client_id_custom: dataMetrics.client_id || DOES_NOT_APPLY,
            user_id_custom: this.getUserId() || DOES_NOT_APPLY,
            parent_id_custom:  this.getParentId() || DOES_NOT_APPLY,
            device_model: dataMetrics.device_model || DOES_NOT_APPLY,
            device_name: dataMetrics.device_name || DOES_NOT_APPLY,
            authpn: dataMetrics.authpn || DOES_NOT_APPLY,
            content_id: dataMetrics.content_id || DOES_NOT_APPLY,
            content_name: dataMetrics.content_name || DOES_NOT_APPLY,
            content_type: dataMetrics.content_type || DOES_NOT_APPLY,
            content_category: dataMetrics.content_category || DOES_NOT_APPLY,
            content_availability: dataMetrics.content_availability || DOES_NOT_APPLY,
            content_episode: dataMetrics.content_episode || DOES_NOT_APPLY,
            content_price: dataMetrics.content_price || DOES_NOT_APPLY,
            content_season: dataMetrics.content_season || DOES_NOT_APPLY,
            provider: dataMetrics.provider || DOES_NOT_APPLY,
            content_position: dataMetrics.content_position || DOES_NOT_APPLY,
            content_list: dataMetrics.content_list || DOES_NOT_APPLY,
            content_list_id: dataMetrics.content_list_id || DOES_NOT_APPLY
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }

    public sendMetricsSelectContentHBO(dataMetrics: any) {
        const dataLayerRaw = this.cleanDataLayer({
            event: SELECT_CONTENT,
            timestamp_micros: Utils.nowAsTimestampSeconds() * 1000000,
            client_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id: this.getUserId() || DOES_NOT_APPLY,
            parent_id: this.getParentId() || DOES_NOT_APPLY,
            sign_up_method: store.getState().user.type === OTT ? METHOD_EMAIL : SERIAL || DOES_NOT_APPLY,
            client_id_custom: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id_custom: this.getUserId() || DOES_NOT_APPLY,
            user_type: getUserType() || DOES_NOT_APPLY,
            parent_id_custom: this.getParentId() || DOES_NOT_APPLY,
            suscriptions: this.getSubscriptions(),
            page_path: dataMetrics.page_path || DOES_NOT_APPLY,
            page_title: dataMetrics.page_title || DOES_NOT_APPLY,
            page_url: dataMetrics.page_url || DOES_NOT_APPLY,
            previous_path: dataMetrics.history && dataMetrics.history.location && dataMetrics.history.location.pathname ? dataMetrics.history.location.pathname : DOES_NOT_APPLY,
            country: getCountry() || DOES_NOT_APPLY,
            engagement_time_msec: Utils.nowAsTimestampSeconds() * 1000000,
            session_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            device: Device.getDevice().getPlatform() || DOES_NOT_APPLY,
            device_model: Device.getDevice().config.device_model || DOES_NOT_APPLY,
            device_name: Device.getDevice().config.device_name || DOES_NOT_APPLY,
            authpn: getAppConfig().authpn || DOES_NOT_APPLY,
            os_version: Device.getDevice().config.osversion || DOES_NOT_APPLY,
            content_section: dataMetrics.content_section || DOES_NOT_APPLY,
            content_subsection: DOES_NOT_APPLY,
            content_id: dataMetrics.content_id || DOES_NOT_APPLY,
            content_name: dataMetrics.content_name || DOES_NOT_APPLY,
            content_type: DOES_NOT_APPLY,
            content_category: DOES_NOT_APPLY,
            content_availability: dataMetrics.content_availability || DOES_NOT_APPLY,
            content_episode: dataMetrics.content_episode || DOES_NOT_APPLY,
            content_season: dataMetrics.content_season || DOES_NOT_APPLY,
            provider: dataMetrics.provider || DOES_NOT_APPLY,
            content_position: dataMetrics.content_position || DOES_NOT_APPLY,
            content_list: dataMetrics.content_list || DOES_NOT_APPLY,
            content_list_id: dataMetrics.content_list_id || DOES_NOT_APPLY,
            modulo_name: dataMetrics.modulo_name || DOES_NOT_APPLY,
            interaction_type: dataMetrics.interaction_type || ACTIVAR_HBO,
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }

    public sendMetricsEventErrorHBO(dataMetrics: any) {
        const dataLayerRaw = this.cleanDataLayer({
            event: EVENT_ERROR,
            timestamp_micros: Utils.nowAsTimestampSeconds() * 1000000,
            client_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id: this.getUserId() || DOES_NOT_APPLY,
            parent_id: this.getParentId() || DOES_NOT_APPLY,
            sign_up_method: store.getState().user.type === OTT ? METHOD_EMAIL : SERIAL || DOES_NOT_APPLY,
            client_id_custom: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id_custom: this.getUserId() || DOES_NOT_APPLY,
            user_type: getUserType() || DOES_NOT_APPLY,
            suscriptions: this.getSubscriptions(),
            content_section: dataMetrics.content_section || DOES_NOT_APPLY,
            content_subsection: dataMetrics.content_subsection || DOES_NOT_APPLY,
            page_path: dataMetrics.page_path || DOES_NOT_APPLY,
            page_title: dataMetrics.page_title || DOES_NOT_APPLY,
            page_url: dataMetrics.page_url || DOES_NOT_APPLY,
            previous_path: dataMetrics.history && dataMetrics.history.location && dataMetrics.history.location.pathname ? dataMetrics.history.location.pathname : DOES_NOT_APPLY,
            device: Device.getDevice().getPlatform() || DOES_NOT_APPLY,
            os_version: Device.getDevice().config.osversion || DOES_NOT_APPLY,
            country: getCountry() || DOES_NOT_APPLY,
            engagement_time_msec: Utils.nowAsTimestampSeconds() * 1000000,
            session_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            interaction_type: dataMetrics.interaction_type || DOES_NOT_APPLY,
            modulo_name: dataMetrics.modulo_name || DOES_NOT_APPLY,
            error_title: dataMetrics.error_title || DOES_NOT_APPLY,
            error_message: dataMetrics.error_message || DOES_NOT_APPLY,
            error_type: dataMetrics.error_type || DOES_NOT_APPLY,
            error_code: dataMetrics.error_code || DOES_NOT_APPLY,
            authpn: getAppConfig().authpn || DOES_NOT_APPLY,
            provider: dataMetrics.provider || DOES_NOT_APPLY,
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }

    public sendMetricsActivateHBO(dataMetrics: any) {
        const dataLayerRaw = this.cleanDataLayer({
            event: SELECT_CONTENT,
            timestamp_micros: Utils.nowAsTimestampSeconds() * 1000000,
            client_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id: this.getUserId() || DOES_NOT_APPLY,
            parent_id: this.getParentId() || DOES_NOT_APPLY,
            sign_up_method: store.getState().user.type === OTT ? METHOD_EMAIL : SERIAL || DOES_NOT_APPLY,
            client_id_custom: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            user_id_custom: this.getUserId() || DOES_NOT_APPLY,
            user_type: getUserType() || DOES_NOT_APPLY,
            suscriptions: this.getSubscriptions(),
            page_path: dataMetrics.page_path || DOES_NOT_APPLY,
            page_title: dataMetrics.page_title || DOES_NOT_APPLY,
            page_url: dataMetrics.page_url || DOES_NOT_APPLY,
            previous_path: dataMetrics.history && dataMetrics.history.location && dataMetrics.history.location.pathname ? dataMetrics.history.location.pathname : DOES_NOT_APPLY,
            country: getCountry() || DOES_NOT_APPLY,
            engagement_time_msec: Utils.nowAsTimestampSeconds() * 1000000,
            session_id: Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
            device: Device.getDevice().getPlatform() || DOES_NOT_APPLY,
            device_model: Device.getDevice().config.device_model || DOES_NOT_APPLY,
            device_name: Device.getDevice().config.device_name || DOES_NOT_APPLY,
            authpn: getAppConfig().authpn || DOES_NOT_APPLY,
            os_version: Device.getDevice().config.osversion || DOES_NOT_APPLY,
            content_section: dataMetrics.content_section || DOES_NOT_APPLY,
            content_subsection: dataMetrics.content_subsection || DOES_NOT_APPLY,
            content_id: dataMetrics.content_id,
            content_name: dataMetrics.content_name,
            content_type: dataMetrics.content_type || DOES_NOT_APPLY,
            content_category: SPORTS || DOES_NOT_APPLY,
            content_availability: dataMetrics.content_availability || DOES_NOT_APPLY,
            content_episode: dataMetrics.content_episode || DOES_NOT_APPLY,
            content_season: dataMetrics.content_season || DOES_NOT_APPLY,
            provider: dataMetrics.provider || DOES_NOT_APPLY,
            content_position: dataMetrics.content_position || DOES_NOT_APPLY,
            content_list: dataMetrics.content_list || DOES_NOT_APPLY,
            content_list_id: dataMetrics.content_list_id || DOES_NOT_APPLY,
            interaction_type: dataMetrics.interaction_type || DOES_NOT_APPLY,
            modulo_name: dataMetrics.modulo_name || DOES_NOT_APPLY,
        });

        this.send(dataLayerRaw, '[sendEvent]');
    }

        /**
         * Evento migration_impression — se dispara cuando el modal de migración
         * toma el foco visual (componentDidMount).
         * @param dataMetrics Payload tipado con los campos de contexto del modal
         */
        /**
         * Campos comunes a migration_impression y migration_click.
         * Extraído para evitar duplicación (DRY).
         */
        private buildMigrationBasePayload(dataMetrics: IMigrationMetricsPayload): object {
            return {
                client_id:            Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
                user_id:              this.getUserId() || DOES_NOT_APPLY,
                parent_id:            this.getParentId() || DOES_NOT_APPLY,
                client_id_custom:     Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
                user_id_custom:       this.getUserId() || DOES_NOT_APPLY,
                sign_up_method:       store.getState().user.type === OTT ? METHOD_EMAIL : SERIAL,
                user_type:            getUserType() || DOES_NOT_APPLY,
                suscriptions:         this.getSubscriptions(),
                timestamp_micros:     Utils.nowAsTimestampSeconds() * 1000000,
                engagement_time_msec: Utils.nowAsTimestampSeconds() * 1000000,
                session_id:           Utils.getCookie('_gcl_au') || DOES_NOT_APPLY,
                page_path:            dataMetrics.page_path,
                page_title:           dataMetrics.page_title,
                previous_path:        dataMetrics.previous_path,
                modulo_name:          dataMetrics.modulo_name,
                migration_type:       dataMetrics.migration_type,
                device:               Device.getDevice().getPlatform() || DOES_NOT_APPLY,
                os_version:           Device.getDevice().config.osversion || DOES_NOT_APPLY,
                country:              getCountry() || DOES_NOT_APPLY,
                app_id:               'com.claro.clarovideo.ott',
                app_version:          DeviceStorage.getItem('appVersion') || DOES_NOT_APPLY,
                app_name:             'claro_video',
            };
        }

        public sendMigrationImpressionEvent(dataMetrics: IMigrationMetricsPayload): void {
            if (!this.isEnabled) return;

            const dataLayerRaw = this.cleanDataLayer({
                event: 'migration_impression',
                ...this.buildMigrationBasePayload(dataMetrics),
            });
            this.send(dataLayerRaw, '[migration_impression]');
        }

        /**
         * Evento migration_click — se dispara cuando el usuario selecciona
         * cualquier botón del modal (Descargar Claro tv+ o Más tarde).
         * @param dataMetrics      Payload tipado con los campos de contexto del modal
         * @param interaction_type Acción ejecutada: 'descargar_claro_tv' | 'mas_tarde'
         */
        public sendMigrationClickEvent(dataMetrics: IMigrationMetricsPayload, interaction_type: string): void {
            if (!this.isEnabled) return;

            const dataLayerRaw = this.cleanDataLayer({
                event: 'migration_click',
                ...this.buildMigrationBasePayload(dataMetrics),
                interaction_type,
            });
            this.send(dataLayerRaw, '[migration_click]');
        }

}

export const getUserType = () => {
    const { user : {isAnonymous = false}= {} } = store.getState() || {};
    if (isAnonymous) return USER_TYPE_ANONIMO;
    return USER_TYPE_REGISTRADO
}

const getCountry = () => {
    return DeviceStorage.getItem('region') || '';
}








// WEBPACK FOOTER //
// ./src/utils/trackers/GA4.ts